export default __webpack_public_path__ + "static/media/i-fb.c7d46e03.svg";